import * as React from 'react'

/**
 * @deprecated Please do not use this
 **/
type ConditionalWrapperProps = {
  condition: unknown
  wrapper: (children: React.ReactNode) => React.JSX.Element
  children: React.ReactNode
}
export default function ConditionalWrapper({
  condition,
  wrapper,
  children,
}: ConditionalWrapperProps): React.JSX.Element {
  return <>{condition ? wrapper(children) : children}</>
}
